import { useMemo, useRef, useState } from "react";

type Props = {
  videoId: string;
  title: string;
};

export function FloatingShortVideo({ videoId, title }: Props) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [closed, setClosed] = useState(false);
  const [closing, setClosing] = useState(false);
  const [soundEnabled, setSoundEnabled] = useState(false);

  const src = useMemo(() => {
    const params = new URLSearchParams({
      autoplay: "1",
      mute: "1",
      playsinline: "1",
      loop: "1",
      playlist: videoId,
      controls: "1",
      rel: "0",
      enablejsapi: "1",
      origin: window.location.origin,
    });
    return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
  }, [videoId]);

  if (closed) return null;

  const close = () => {
    setClosing(true);
    window.setTimeout(() => setClosed(true), 360);
  };

  const sendYouTubeCommand = (func: string, args: unknown[] = []) => {
    iframeRef.current?.contentWindow?.postMessage(
      JSON.stringify({ event: "command", func, args }),
      "https://www.youtube.com",
    );
  };

  const enableSound = () => {
    setSoundEnabled(true);
    sendYouTubeCommand("setVolume", [100]);
    sendYouTubeCommand("unMute");
    sendYouTubeCommand("playVideo");
  };

  return (
    <aside
      className={`floating-short${closing ? " is-closing" : ""}`}
      aria-label="Vídeo de apresentação UdiSchool"
    >
      <button
        type="button"
        className="floating-short-close"
        onClick={close}
        aria-label="Fechar vídeo"
      >
        ×
      </button>
      {!soundEnabled && (
        <button
          type="button"
          className="floating-short-sound"
          onClick={enableSound}
          aria-label="Ativar som do vídeo"
        >
          Som
        </button>
      )}
      <iframe
        ref={iframeRef}
        src={src}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </aside>
  );
}
